import loansService from '../../services/loan.service';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { AutopayResponse, BankAccountInput } from '../../gql/graphql';
import { NetworkError } from '../../state-machine/actions/genericActions';

const enrollInAutopay = async (orderId: string, accountDetails: BankAccountInput | null): Promise<AutopayResponse> => {
  try {
    const response = await loansService.enrollInAutopay({ orderId, accountDetails });
    return response.data?.enrollInAutopay as AutopayResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default enrollInAutopay;
